import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import SEO from "@/components/SEO";
import { STORE_NAME } from "@/lib/seo";

export default function Contact() {
    const { settings } = useSettings();
    return (
        <div className="container mx-auto px-4 py-10 max-w-3xl" data-testid="contact-page">
            <SEO
                title={`Contact ${STORE_NAME} — Customer Support in India`}
                description={`Get in touch with ${STORE_NAME} for product help, orders, and fishing tackle inquiries. Email, phone, WhatsApp and Instagram.`}
                path="/contact"
            />
            <h1 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight">Contact</h1>
            <p className="text-white/65 mt-2">
                We'd love to help you find the right gear. Reach out via any channel below.
            </p>
            <div className="mt-8 grid sm:grid-cols-2 gap-3">
                {settings?.contact_email && (
                    <a
                        href={`mailto:${settings.contact_email}`}
                        className="border border-[#27272A] bg-[#121214] rounded-sm p-5 flex items-start gap-3 card-hover"
                        data-testid="contact-email"
                    >
                        <Mail className="text-[#00BCE5]" />
                        <div>
                            <div className="text-xs uppercase tracking-widest text-white/55 font-display">Email</div>
                            <div className="font-medium">{settings.contact_email}</div>
                        </div>
                    </a>
                )}
                {settings?.contact_phone && (
                    <a
                        href={`tel:${settings.contact_phone}`}
                        className="border border-[#27272A] bg-[#121214] rounded-sm p-5 flex items-start gap-3 card-hover"
                        data-testid="contact-phone"
                    >
                        <Phone className="text-[#00BCE5]" />
                        <div>
                            <div className="text-xs uppercase tracking-widest text-white/55 font-display">Phone</div>
                            <div className="font-medium">{settings.contact_phone}</div>
                        </div>
                    </a>
                )}
                {settings?.address && (
                    <div className="border border-[#27272A] bg-[#121214] rounded-sm p-5 flex items-start gap-3">
                        <MapPin className="text-[#00BCE5]" />
                        <div>
                            <div className="text-xs uppercase tracking-widest text-white/55 font-display">Address</div>
                            <div className="font-medium">{settings.address}</div>
                        </div>
                    </div>
                )}
                {settings?.instagram_url && (
                    <a
                        href={settings.instagram_url}
                        target="_blank"
                        rel="noreferrer"
                        className="border border-[#27272A] bg-[#121214] rounded-sm p-5 flex items-start gap-3 card-hover"
                        data-testid="contact-instagram"
                    >
                        <Instagram className="text-[#00BCE5]" />
                        <div>
                            <div className="text-xs uppercase tracking-widest text-white/55 font-display">Instagram</div>
                            <div className="font-medium">{settings.instagram_handle || "@openseafishingtackles"}</div>
                        </div>
                    </a>
                )}
            </div>
        </div>
    );
}
